/**
 * Test fixtures for the session domain layer. These mirror Ascend Health Plus
 * (AHP)'s inbound `POST /api/v1/sessions` payload: nested `provider`/`member`
 * objects, "YYYY-MM-DD HH:mm:ss +HHMM" datetimes, and a `checkins[]` array.
 */

import type { RawCoreSession } from './mapping'

/** A confirmed, face-to-face session with two check-in/out records. */
export const RAW_CONFIRMED_FACE_TO_FACE: RawCoreSession = {
  uuid: '11111111-1111-4111-8111-111111111111',
  provider: {
    email: 'ania@ascendhealthgroup.com.au',
    first_name: 'Ania',
    last_name: 'Quitzon',
  },
  member: {
    email: 'abdul.stehr@example.com',
    first_name: 'Abdul',
    last_name: 'Stehr',
  },
  location: '93168 Pfeffer Forges, Narrogin, 6312, Western Australia',
  start: '2026-01-31 08:00:00 +0800',
  end: '2026-01-31 09:00:00 +0800',
  status: 'confirmed',
  service_type: 'Physiotherapy',
  face_to_face: true,
  non_face_to_face_session_type: null,
  notes: '',
  checkins: [
    { kind: 'check_in', occurred_at: '2026-01-31 08:02:00 +0800', latitude: -32.936, longitude: 117.178 },
    { kind: 'check_out', occurred_at: '2026-01-31 08:58:00 +0800', latitude: -32.936, longitude: 117.178 },
  ],
}

/** A requested (not yet confirmed) session. */
export const RAW_REQUESTED: RawCoreSession = {
  uuid: '44444444-4444-4444-8444-444444444444',
  provider: { email: 'ania@ascendhealthgroup.com.au', first_name: 'Ania', last_name: 'Quitzon' },
  member: { email: 'abdul.stehr@example.com', first_name: 'Abdul', last_name: 'Stehr' },
  location: '93168 Pfeffer Forges, Narrogin, 6312, Western Australia',
  start: '2026-04-10 13:00:00 +0800',
  end: '2026-04-10 14:00:00 +0800',
  status: 'requested',
  service_type: 'Support Work',
  face_to_face: true,
  notes: '',
  checkins: [],
}

/** A completed session (no checkins listed). */
export const RAW_COMPLETED_NO_SERIES: RawCoreSession = {
  uuid: '22222222-2222-4222-8222-222222222222',
  provider: { email: 'ania@ascendhealthgroup.com.au', first_name: 'Ania', last_name: 'Quitzon' },
  member: { email: 'abdul.stehr@example.com', first_name: 'Abdul', last_name: 'Stehr' },
  location: '93168 Pfeffer Forges, Narrogin, 6312, Western Australia',
  start: '2026-02-23 08:00:00 +0800',
  end: '2026-02-23 10:00:00 +0800',
  status: 'completed',
  service_type: 'Support Work',
  face_to_face: true,
  notes: '',
  checkins: [],
}

/** A telehealth (non-face-to-face) session. */
export const RAW_TELEHEALTH: RawCoreSession = {
  uuid: '33333333-3333-4333-8333-333333333333',
  provider: { email: 'ania@ascendhealthgroup.com.au', first_name: 'Ania', last_name: 'Quitzon' },
  member: { email: 'abdul.stehr@example.com', first_name: 'Abdul', last_name: 'Stehr' },
  location: 'Telehealth',
  start: '2026-03-01 10:00:00 +0800',
  end: '2026-03-01 10:30:00 +0800',
  status: 'confirmed',
  service_type: 'Telehealth Consult',
  face_to_face: false,
  non_face_to_face_session_type: 'video',
  notes: '',
  checkins: [],
}

export const RAW_SESSIONS: RawCoreSession[] = [
  RAW_CONFIRMED_FACE_TO_FACE,
  RAW_COMPLETED_NO_SERIES,
  RAW_TELEHEALTH,
]
